import { render, staticRenderFns } from "./MessageAttachment.vue?vue&type=template&id=cb2dd8b2&scoped=true&"
import script from "./MessageAttachment.vue?vue&type=script&lang=js&"
export * from "./MessageAttachment.vue?vue&type=script&lang=js&"
import style0 from "./MessageAttachment.vue?vue&type=style&index=0&id=cb2dd8b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2dd8b2",
  null
  
)

export default component.exports